"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _loglevel = _interopRequireDefault(require("loglevel"));

var MODULE_NAME = 'sdk/media/services/userMedia';

var logger = _loglevel.default.getLogger(MODULE_NAME);

var NO_MEDIA_PERMISSIONS = 'NO_MEDIA_PERMISSIONS';

var getUserMedia = function getUserMedia(constraints) {
  logger.info("".concat(MODULE_NAME, " - getUserMedia called"), constraints);
  return new Promise(function (resolve, reject) {
    navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
      logger.debug("".concat(MODULE_NAME, " - getUserMedia stream"), stream);
      resolve(stream);
    }).catch(function (err) {
      logger.debug("".concat(MODULE_NAME, " - getUserMedia error"), err);
      reject(NO_MEDIA_PERMISSIONS);
    });
  });
};

var _default = {
  NO_MEDIA_PERMISSIONS: NO_MEDIA_PERMISSIONS,
  getUserMedia: getUserMedia
};
exports.default = _default;
module.exports = exports.default;